import type {FileBrowserFile} from './types';

export interface Node {
  files: FileBrowserFile[];
  subdirectories: {[key: string]: Node};
  totalFileCount: number;
  totalSize: number;
}

// takes a flat array of file objects and converts it into a nested object, based on filenames
export function makeFileTree(filesArray: FileBrowserFile[]): Node {
  const fileTree: Node = {
    files: [],
    subdirectories: {},
    totalFileCount: 0,
    totalSize: 0,
  };
  filesArray.forEach(file => {
    let currentFolder = fileTree;
    // 'media/images/image01.jpg' => ['media','images','image01.jpg']
    const path = file.name.split('/');
    while (path.length > 1) {
      // The following is safe to do because we made sure path had elems in the loop condition.
      const folderName = path.shift() as string;
      // create subfolder if it doesn't already exist
      if (!currentFolder.subdirectories[folderName]) {
        currentFolder.subdirectories[folderName] = {
          files: [],
          subdirectories: {},
          totalFileCount: 0,
          totalSize: 0,
        };
      }
      currentFolder.subdirectories[folderName].totalFileCount += 1;
      currentFolder.subdirectories[folderName].totalSize += file.sizeBytes;
      currentFolder = currentFolder.subdirectories[folderName];
    }
    // if we've come to the last item in the path, add this file object to the current folder
    currentFolder.files.push(file);
  });
  return fileTree;
}
